import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../components/Loader";
import BookingJourneySelector from "./BookingJourneySelector";
import CorporateBookingForm from "../new-booking-form/CorporateBookingForm";
import { BOOKING_AS, BOOKING_FORM_STATUS } from "../../config/constant";
import {
  getApplicantDetails,
  getOppprtunityDetails,
  setKycVerificationActiveStep,
  setIsCorporateFlow,
  setEntity,
  getMasterDataList,
  setResetData,
  setApplicantTotal,
  setActiveStep,
  setIsFromPreview,
  setProjectBrandImage,
  setEditPreviewApplicant,
  setProjectId,
  setBrandId,
  getTermsAndCondition,
} from "../new-booking-form/new-booking-form.slice";

import { useTranslation } from "react-i18next";
import IndividualCustomerForm from "../new-booking-form/IndividualCustomerForm";
import { useHandleRedirection } from "../new-booking-form/hooks/useHandleRedirection";
import SnackbarAlert from "../../shared-components/snackbar-alert/SnackbarAlert";

const BookingHandler = () => {
  const { oppId } = useParams();
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const {
    isFromPreview,
    isLoading,
    applicantData,
  } = useSelector((state) => state.newBookingForm);
  const [snackbarConfig, setSnackbarConfig] = useState({
    open: false,
    message: "",
    severity: "error",
  });

  const [step, setStep] = useState("select");
  const [bookingAs, setBookingAs] = useState("");
  const [selectedJourney, setSelectedJourney] = useState("");
  const history = useHistory();
  const { handleRedirection } = useHandleRedirection();

  useEffect(() => {
    if (applicantData?.opportunityId !== oppId) {
      dispatch(setResetData());
    }
  }, []);

  useEffect(() => {
    dispatch(getOppprtunityDetails(`/${oppId}`))
      .unwrap()
      .then((res) => {
        if (res) {
          dispatch(setKycVerificationActiveStep(0));

          dispatch(
            getTermsAndCondition(
              `/${res?.data?.ProjectName}/${res?.data?.projectBrandName}`,
            ),
          )
            .unwrap()
            .then((termsData) => {
              if (termsData) {
                const projectId = termsData?.id;
                const brandId = termsData?.brandId;

                if (projectId) dispatch(setProjectId(projectId));
                if (brandId) dispatch(setBrandId(brandId));

                dispatch(setProjectBrandImage(termsData?.brandLogo || ""));
              }
            })
            .catch((error) => {
              dispatch(setProjectBrandImage(""));
            });
          dispatch(getMasterDataList());

          dispatch(getApplicantDetails(`/${oppId}`))
            .unwrap()
            .then((res) => {
              if (!res?.isAgreedOnTerms) {
                dispatch(setEditPreviewApplicant(false));
              }
              if (res?.bookingAs) {
                setBookingAs(res?.bookingAs);
                setStep("form");
                dispatch(
                  setIsCorporateFlow(res?.bookingAs === BOOKING_AS.CORPORATE),
                );
                dispatch(
                  setEntity(
                    res?.bookingAs === BOOKING_AS.PARTNERSHIP_FIRM
                      ? t("entity.firm")
                      : t("entity.company"),
                  ),
                );
              } else {
                //dispatch(getApplicantDetails(`/${oppId}`));
              }
              if (res) {
                handleRedirection(res);
              }
              if (res?.signedPdf === null) {
                if (
                  res?.leegalityData?.isSignLater === true ||
                  applicantData?.bookingFormStatus ===
                    BOOKING_FORM_STATUS?.PARTIALLY_SIGNED ||
                  applicantData?.bookingFormStatus ===
                    BOOKING_FORM_STATUS?.NOT_SIGNED ||
                  applicantData?.bookingFormStatus ===
                    BOOKING_FORM_STATUS?.SIGNED_OFFLINE
                ) {
                  //history.push(`/customer-preview/${oppId}`);
                } else {
                  dispatch(setApplicantTotal(res?.noOfApplicants));
                  if (!isFromPreview?.value) {
                    dispatch(setActiveStep(res?.lastStep || 0));
                  } else {
                    dispatch(setActiveStep(isFromPreview?.index || 0));
                    dispatch(setIsFromPreview({ value: false, index: null }));
                  }
                }
              }
              if (res?.signedPdf !== null) {
                dispatch(setActiveStep(0));
                //history.push(`/thank-you/${oppId}`);
              }
            })
            .catch((error) => {
              setBookingAs("");
              setStep("select");
              dispatch(setResetData());

              console.error("Failed to Fetch applicant details", error);
            });
        }
      })
      .catch((error) => {
        console.error("Failed to Fetch opportunity details", error);
        history.push("/404");
      });
  }, []);

  const handleJourneySelect = (journey) => {
    // Call the get-booking API again to get updated bookingAs if needed
    setSelectedJourney(journey);
  };

  useEffect(() => {
    if (applicantData?.bookingAs && step === "select") {
      setBookingAs(applicantData?.bookingAs);
      setStep("form");
    }
  }, [applicantData?.bookingAs, step]);

  useEffect(() => {
    if (selectedJourney) {
      setStep(selectedJourney);
      setBookingAs(selectedJourney);
      if (selectedJourney === BOOKING_AS.CORPORATE) {
        dispatch(setIsCorporateFlow(true));
        dispatch(setEntity(t("entity.company")));
      }
      if (selectedJourney === BOOKING_AS.PARTNERSHIP_FIRM) {
        dispatch(setIsCorporateFlow(false));
        dispatch(setEntity(t("entity.firm")));
      }
    }
  }, [selectedJourney]);

  const handleSnackbarClose = () => {
    setSnackbarConfig({
      open: false,
      message: "",
      severity: "error",
    });
  };

  if (isLoading && step === "select") {
    return <Loader isLoading={isLoading} />;
  }

  if (step === "select") {
    return (
    <>
      <BookingJourneySelector onContinue={handleJourneySelect} 
        onError={(message) => setSnackbarConfig({
          open: true,
          message,
          severity: "error",
        })
      } />
      <SnackbarAlert
        open={snackbarConfig.open}
        message={snackbarConfig.message}
        severity={snackbarConfig.severity}
        onClose={handleSnackbarClose}
      />
    </>
    )
  } else {
    if (bookingAs === BOOKING_AS.INDIVIDUAL) {
      return (
      <>
        <IndividualCustomerForm />
        <SnackbarAlert
          open={snackbarConfig.open}
          message={snackbarConfig.message}
          severity={snackbarConfig.severity}
          onClose={handleSnackbarClose}
        />
      </>
      )
    } else {
      return (
      <>
      <CorporateBookingForm />
      <SnackbarAlert
        open={snackbarConfig.open}
        message={snackbarConfig.message}
        severity={snackbarConfig.severity}
        onClose={handleSnackbarClose}
      />
      </>
      )
    }
  }
};

export default BookingHandler;
